module.exports = __webpack_public_path__ + "img/img2.69442525.png";